module.exports = __webpack_public_path__ + "img/empty-6.e495783e.svg";